export default "__VITE_ASSET__DKxK_daV__"